import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node) => {
  const ACTIVE_CLASS = 'is-sticky';

  // Observe when position sticky
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 1) {
          node.classList.add(ACTIVE_CLASS);
        } else {
          node.classList.remove(ACTIVE_CLASS);
        }
      });
    },
    {
      rootMargin: '-1px 0px 0px 0px',
      threshold: [1],
    },
  );

  observer.observe(node);
};

export default Component;
